<template>
  <div class="loader-filter" :class="{'loader-filter--is-loading': isLoading, 'loader-filter--without-opacity': withoutOpacity, 'loader-filter--without-background': withoutBackground}">
    <div class="loader" :style="{border: borderSize + 'px solid #f3f3f3', borderTop: borderSize + 'px solid #FF2F00'}"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    withoutOpacity: {
      type: Boolean,
      required: false
    },
    withoutBackground: {
      type: Boolean,
      required: false
    },
    // Задает ширину лоадера
    borderSize: {
      type: Number,
      default: 7
    }
  }
}
</script>

<style scoped lang="sass">
.loader-filter
  display: none
  position: absolute
  background: rgba(255, 255, 255, 0.6)
  height: 100%
  width: 100%
  top: 0
  left: 0
  z-index: 999

  &--is-loading
    display: flex
    align-items: center
    justify-content: center

    .loader
      display: block

  &--without-opacity
    position: fixed

  &--without-background
    background: transparent

</style>
